import React, { FC, Dispatch, useState } from 'react'; // useStateを追加
import NumberFormat from 'react-number-format';
import { Setting } from '../../App';
import classes from '../../asset/css/subscription-detail/product-item-pickup.module.css';
import { useSubscriptionLine } from '../../hooks/use-subscription-line';
import { SubscriptionType } from '../../types/api/subscriptions-api-type';
import { ProductInfoViewType } from '../../types/view/product-info-view-type';
import { RecommendProductInfoViewType } from '../../types/view/recommend-product-info-view-type';
import { SummaryViewType } from '../../types/view/summary-view-type';

export const ProductItemPickup: FC<{
  productItem: ProductInfoViewType;
  loading: boolean;
  message?: string;
  setting: Setting;
  addProductSuccess: (showModal: boolean) => void;
  failed: (message: string) => void;
  setSubscriptionContractId: Dispatch<string>;
  setRegisteredProducts: Dispatch<ProductInfoViewType[]>;
  setPausedProducts: Dispatch<ProductInfoViewType[]>;
  setRecommendProducts: Dispatch<RecommendProductInfoViewType[]>;
  setSubscription: Dispatch<SubscriptionType>;
}> = ({
  productItem,
  loading,
  message,
  setting,
  addProductSuccess,
  failed,
  setSubscriptionContractId,
  setRegisteredProducts,
  setPausedProducts,
  setRecommendProducts,
  setSubscription,
}) => {
  // ローカルな状態を追加
  const [isAdding, setIsAdding] = useState(false);

  const priceBlock = (
    <span className={classes.pickupItem_info_content_priceBlock_current}>
      <small>割引価格</small> ￥<NumberFormat displayType="text" value={productItem.price} thousandSeparator={true} />
    </span>
  );

  const messageBlock = message ? (
    <div className={classes.pickupItem_info_content_messageBlock}>
      <p className={classes.pickupItem_info_content_messageBlock_msg}>{message}</p>
      <div className={classes.pickupItem_info_content_messageBlock_avatar} />
    </div>
  ) : (
    <></>
  );

  const { addProduct } = useSubscriptionLine(setting, setSubscription);

  const handleAddToBox = () => {
    if (isAdding || loading) {
      // 既に処理中の場合は何もしない
      return;
    }

    setIsAdding(true); // 処理開始

    addProduct(
      productItem.planId!,
      productItem.variantId,
      1,
      () => {
        addProductSuccess(true);
        setIsAdding(false); // 処理完了
      },
      setSubscriptionContractId,
      setRegisteredProducts,
      setPausedProducts,
      setRecommendProducts,
      (errorMessage: string) => {
        failed(errorMessage);
        setIsAdding(false); // エラー時も処理完了
      }
    );
  };

  return (
    <li className={classes.pickupItem}>
      <div className={classes.pickupItem_container}>
        <a href={productItem.url} target="_blank" rel="noopener noreferrer" className={classes.pickupItem_thumbnail}>
          <div
            style={productItem.image ? { backgroundImage: `url('${productItem.image}')` } : {}}
            className={classes.pickupItem_thumbnail_img}
          />
        </a>

        <div className={classes.pickupItem_info}>
          {/* 商品名・価格・メッセージ */}
          <div className={classes.pickupItem_info_content}>
            {/* 商品名 */}
            <h4 className={classes.pickupItem_info_content_title}>{productItem.productTitle}</h4>
            {/* 価格 */}
            <div className={classes.pickupItem_info_content_priceBlock}>{priceBlock}</div>

            {/* メッセージ */}
            <div className={classes.pickupItem_info_pcMessage}>{messageBlock}</div>
          </div>

          {/* アクションボタン */}
          <div className={classes.pickupItem_info_actions}>
            <button
              className={classes.pickupItem_info_actions_addBtn}
              disabled={loading || isAdding} // loadingまたはisAddingで無効化
              onClick={handleAddToBox}
            >
              {isAdding ? '追加中...' : 'BOXに追加'} {/* 状態に応じてボタンテキストを変更 */}
            </button>
          </div>
        </div>
      </div>

      <div className={classes.pickupItem_info_spMessage}>
        {/* SP時メッセージ */}
        {messageBlock}
      </div>
    </li>
  );
};
